// MHM-6.D · Central status-badge component used by drawer, parcel rows,
// inbound list, packer dashboard, etc. Eight distinct colors per the user
// spec (pickup_assigned amber, picked blue, packing_in_progress orange-light,
// packed orange/brand, handed_over purple, received teal, delayed red,
// failed dark red).
import React from "react";

const PALETTE = {
  // Pickup leg
  pickup_assigned:      { bg: "bg-amber-100",   tx: "text-amber-800",   bd: "border-amber-200",   label: "Pickup Assigned" },
  en_route:             { bg: "bg-amber-100",   tx: "text-amber-800",   bd: "border-amber-200",   label: "En Route" },
  picked:               { bg: "bg-blue-100",    tx: "text-blue-800",    bd: "border-blue-200",    label: "Picked" },
  pickup_completed:     { bg: "bg-blue-100",    tx: "text-blue-800",    bd: "border-blue-200",    label: "Pickup Completed" },
  // Packing leg
  packing_in_progress:  { bg: "bg-orange-50",   tx: "text-orange-700",  bd: "border-orange-200",  label: "Packing" },
  in_progress:          { bg: "bg-orange-50",   tx: "text-orange-700",  bd: "border-orange-200",  label: "Packing" },
  packed:               { bg: "bg-[#FFEAD9]",   tx: "text-[#C2410C]",   bd: "border-[#FED7AA]",   label: "Packed" },
  done:                 { bg: "bg-[#FFEAD9]",   tx: "text-[#C2410C]",   bd: "border-[#FED7AA]",   label: "Packed" },
  ready_for_main_hub:   { bg: "bg-[#FFEAD9]",   tx: "text-[#C2410C]",   bd: "border-[#FED7AA]",   label: "Ready for Main Hub" },
  // Handover leg
  handed_over:              { bg: "bg-purple-100", tx: "text-purple-800", bd: "border-purple-200", label: "Handed Over" },
  handed_over_to_main_hub:  { bg: "bg-purple-100", tx: "text-purple-800", bd: "border-purple-200", label: "Handed Over" },
  // Received at Main Hub
  received_at_main_hub: { bg: "bg-teal-100",    tx: "text-teal-800",    bd: "border-teal-200",    label: "Received at Main Hub" },
  // Delivery leg
  assigned:             { bg: "bg-amber-100",   tx: "text-amber-800",   bd: "border-amber-200",   label: "Assigned" },
  out_for_delivery:     { bg: "bg-sky-100",     tx: "text-sky-800",     bd: "border-sky-200",     label: "Out for Delivery" },
  delivered:            { bg: "bg-green-100",   tx: "text-green-800",   bd: "border-green-200",   label: "Delivered" },
  // Exceptions
  delayed:              { bg: "bg-red-100",     tx: "text-red-800",     bd: "border-red-200",     label: "Delayed" },
  failed:               { bg: "bg-rose-200",    tx: "text-rose-900",    bd: "border-rose-300",    label: "Failed" },
  rto:                  { bg: "bg-rose-100",    tx: "text-rose-800",    bd: "border-rose-200",    label: "RTO" },
  cancelled:            { bg: "bg-slate-200",   tx: "text-slate-700",   bd: "border-slate-300",   label: "Cancelled" },
  pending:              { bg: "bg-yellow-100",  tx: "text-yellow-800",  bd: "border-yellow-200",  label: "Pending" },
  // ─── Phase APP-1 (approval flows) ────────────────────────────────
  // Yellow = open / awaiting decision, blue = mid-resubmit cycle,
  // red = rejected (initial & terminal), purple = founder override.
  rejected_1:                 { bg: "bg-red-100",     tx: "text-red-800",     bd: "border-red-200",     label: "Rejected" },
  rejected_terminal:          { bg: "bg-red-100",     tx: "text-red-800",     bd: "border-red-200",     label: "Rejected (terminal)" },
  resubmitted_pending:        { bg: "bg-blue-100",    tx: "text-blue-800",    bd: "border-blue-200",    label: "Resubmitted" },
  approved:                   { bg: "bg-green-100",   tx: "text-green-800",   bd: "border-green-200",   label: "Approved" },
  founder_override_approved:  { bg: "bg-purple-100",  tx: "text-purple-800",  bd: "border-purple-200",  label: "Founder override" },
};

const DEFAULT = { bg: "bg-slate-100", tx: "text-slate-700", bd: "border-slate-200", label: "Unknown" };

export default function StatusBadge({ status, label, size = "md", testid }) {
  const key = String(status || "").toLowerCase();
  const p = PALETTE[key] || DEFAULT;
  const sizeCls = size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-1";
  return (
    <span
      data-testid={testid || `status-badge-${key}`}
      data-status={key}
      className={`inline-flex items-center rounded-full font-semibold border ${p.bg} ${p.tx} ${p.bd} ${sizeCls}`}>
      {label || p.label || (status || "").replace(/_/g, " ")}
    </span>
  );
}

export { PALETTE as STATUS_PALETTE };
